import { DocumentTypes, UploadedDocumentInfoDocumentType } from '@urbanx/agx.campaigns.client';
import { AxiosProgressEvent, AxiosRequestConfig, GenericAbortSignal } from 'axios';
import CampaignsService from 'services/campaignsService';

export const getFileLink = async (
  authToken: string,
  filePath: string
): Promise<number | undefined> => {
  try {
    const service = new CampaignsService(authToken);

    const { data: result } = await service.campaignsService.get('GetUploadedFileLink', {
      filePath,
    });

    return result;
  } catch (err) {
    console.log('err', err);
  }
};

export const uploadFile = async (
  authToken: string,
  file: string | FormData,
  campaignId: string,
  uploadedFormType: DocumentTypes,
  onUploadProgressChanged: ((progressEvent: AxiosProgressEvent) => void) | null = null,
  abortSignal: GenericAbortSignal | null = null,
  filePath?: string,
  contractId?: string
): Promise<any> => {
  try {
    const service = new CampaignsService(authToken);
    const params: Record<string, string> = {
      CampaignId: campaignId,
      documentType: uploadedFormType,
    };
    const config: AxiosRequestConfig = {};

    if (contractId) {
      params.ContractId = contractId;
    }

    if (filePath) {
      params.filePath = filePath;
    }

    if (onUploadProgressChanged) {
      config.onUploadProgress = onUploadProgressChanged;
    }

    if (abortSignal) {
      config.signal = abortSignal;
    }

    const { data: result } = await service.campaignsService.post(
      'AddOrUpdateDocument',
      file,
      params,
      {},
      undefined,
      config
    );
    return result;
  } catch (err) {
    console.log('err', err);
  }
};

export const editFile = async (
  authToken: string,
  file: FormData,
  campaignId: string,
  uploadedFormType: UploadedDocumentInfoDocumentType,
  filePath: string,
  onUploadProgressChanged: ((progressEvent: AxiosProgressEvent) => void) | null = null,
  abortSignal: GenericAbortSignal | null = null
): Promise<any> => {
  try {
    const service = new CampaignsService(authToken);
    const config: AxiosRequestConfig = {};

    if (onUploadProgressChanged) {
      config.onUploadProgress = onUploadProgressChanged;
    }

    if (abortSignal) {
      config.signal = abortSignal;
    }

    const { data: result } = await service.campaignsService.post(
      'AddOrUpdateDocument',
      file,
      {
        CampaignId: campaignId,
        documentType: uploadedFormType,
        filePath: filePath,
      },
      {},
      undefined,
      config
    );
    return result;
  } catch (err) {
    console.log('err', err);
  }
};

export const deleteFile = async (
  authToken: string,
  filePath: string
): Promise<number | undefined> => {
  try {
    const service = new CampaignsService(authToken);

    const { status } = await service.campaignsService.post('RemoveFile', {
      filePath,
    });
    return status;
  } catch (err) {
    console.log('err', err);
  }
};
